// Gestar Design System v1 — labels externos, densidad médica

export const DS = {
  gapField:    '10px',
  gapSection:  '24px',
  paddingDialog: '20px',
  heightField: '40px',
};

// ─── Label externo (siempre encima del campo) ────────────────────────────────
export const labelSx = {
  fontSize: 11,
  fontWeight: 600,
  color: 'var(--c-acento)',
  mb: '4px',
  display: 'block',
  lineHeight: 1,
};

// ─── Campo base (sin label flotante) ────────────────────────────────────────
export const fieldSx = {
  '& .MuiOutlinedInput-root': {
    height: '40px',
    color: 'var(--c-texto)',
    '& fieldset': { borderColor: 'rgba(144,202,249,0.2)' },
    '&:hover fieldset': { borderColor: 'rgba(144,202,249,0.38)' },
    '&.Mui-focused fieldset': { borderColor: 'var(--c-acento)' },
  },
  '& .MuiSelect-icon': { color: 'var(--c-acento)' },
  '& .MuiInputBase-input': { py: '10px' },
};

// ─── Campo multiline (sin altura fija) ──────────────────────────────────────
export const multilineFieldSx = {
  '& .MuiOutlinedInput-root': {
    color: 'var(--c-texto)',
    '& fieldset': { borderColor: 'rgba(144,202,249,0.2)' },
    '&:hover fieldset': { borderColor: 'rgba(144,202,249,0.38)' },
    '&.Mui-focused fieldset': { borderColor: 'var(--c-acento)' },
  },
  '& .MuiSelect-icon': { color: 'var(--c-acento)' },
};

// ─── Card de bloque de cobertura médica (o agrupaciones funcionales) ─────────
export const coberturaCardSx = {
  border: '1px solid rgba(144,202,249,0.22)',
  borderLeft: '3px solid rgba(144,202,249,0.35)',
  borderRadius: '6px',
  bgcolor: 'rgba(144,202,249,0.04)',
  p: '14px',
};

// ─── Botones ─────────────────────────────────────────────────────────────────
export const btnPrimary = {
  bgcolor: '#1e56a0',
  color: '#fff',
  '&:hover': { bgcolor: '#1e56a0', filter: 'brightness(1.15)' },
};

export const btnDestructive = {
  color: '#ef5350',
  '&:hover': { bgcolor: 'rgba(239,83,80,0.08)' },
};

// ─── Menú de Select ──────────────────────────────────────────────────────────
export const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: 'var(--c-superficie)',
      backgroundImage: 'none',
      border: '1px solid rgba(144,202,249,0.15)',
      '& .MuiMenuItem-root': {
        color: 'var(--c-texto)',
        fontSize: 14,
        '&:hover': { bgcolor: 'var(--c-primario)' },
        '&.Mui-selected': { bgcolor: 'rgba(144,202,249,0.12)', color: 'var(--c-acento)' },
        '&.Mui-selected:hover': { bgcolor: 'rgba(144,202,249,0.2)' },
      },
    },
  },
};

// ─── Tabla ───────────────────────────────────────────────────────────────────
export const estiloTabla = {
  bgcolor: 'var(--c-superficie)',
  '& .MuiTableCell-root': { color: 'var(--c-texto)', borderColor: 'var(--c-primario)' },
};

// ─── Legado — mantener mientras se migran pantallas restantes ────────────────
export const labelStyle    = { style: { color: 'var(--c-acento)' }, shrink: true };
export const dateLabelStyle = { shrink: true, style: { color: 'var(--c-acento)', backgroundColor: 'var(--c-superficie)', paddingLeft: 4, paddingRight: 4 } };
export const inputStyle    = { style: { color: 'var(--c-texto)' } };
export const dateInputStyle = { style: { color: 'var(--c-texto)', colorScheme: 'dark' } };
export const dialogTitleSx  = { color: 'var(--c-acento)', fontWeight: 600 };
export const dialogPaperProps = { sx: { bgcolor: 'var(--c-superficie)', color: 'var(--c-texto)' } };
